import Vue from 'vue'
import './utils'

// Filters
Vue.filter('capitalize', window.capitalize)